import fetch from '../fetch';
import EndPoints from '../../data/EndPoints';
import Methods from '../../data/Methods';

export default (companyId, offerId, data) => {
	const headers = { 'content-type': 'application/json' };
	return fetch(
		Methods.POST,
		EndPoints.COMPANIES_OFFER_SEND_REMINDER.replace(':companyId', companyId).replace(
			':offerId',
			offerId
		),
		data,
		headers,
		true
	);
};
